/**
 * Component list, register here to setting it in the form
 */
import { Input } from 'ant-design-vue';
import type { Component } from 'vue';
import { createAsyncComponent } from '@mts-fe/utils';
import type { ComponentType } from './types';

const componentMap = new Map<ComponentType | string, Component>();

componentMap.set('Input', Input);
componentMap.set(
  'LongText',
  createAsyncComponent(() => import('./components/LongText.vue')),
);
componentMap.set(
  'ReadonlyText',
  createAsyncComponent(() => import('./components/ReadonlyText.vue')),
);
componentMap.set(
  'ReadonlyNumber',
  createAsyncComponent(() => import('@mts/components/Base/src/ReadonlyNumber.vue')),
);
componentMap.set(
  'ApiSelect',
  createAsyncComponent(() => import('./components/ApiSelect.vue'), { loading: true }),
);
componentMap.set(
  'ApiSegmented',
  createAsyncComponent(() => import('./components/ApiSegmented.vue'), { loading: true }),
);
componentMap.set(
  'ApiRadioGroup',
  createAsyncComponent(() => import('./components/ApiRadioGroup.vue'), { loading: true }),
);
componentMap.set(
  'QuickRangePicker',
  createAsyncComponent(() => import('./components/QuickRangePicker.vue')),
);
componentMap.set(
  'Stepper',
  createAsyncComponent(() => import('./components/Stepper.vue'), { loading: true }),
);
componentMap.set(
  'VirtualInput',
  createAsyncComponent(() => import('./components/VirtualInput.vue'), { loading: true }),
);
componentMap.set(
  'Textarea',
  createAsyncComponent(() => import('ant-design-vue/es/input').then((module) => module.Textarea), {
    loading: true,
  }),
);
componentMap.set(
  'DatePicker',
  createAsyncComponent(() => import('ant-design-vue/es/date-picker'), { loading: true }),
);
componentMap.set(
  'RangePicker',
  createAsyncComponent(
    () => import('ant-design-vue/es/date-picker').then((module) => module.RangePicker),
    { loading: true },
  ),
);
componentMap.set(
  'Switch',
  createAsyncComponent(() => import('ant-design-vue/es/switch'), { loading: true }),
);

export { componentMap };
